/**
 * Safely decodes a URI component string
 */
export function safeDecodeURIComponent(str: string): string {
  if (!str) return str;

  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}
